import UserUpdate from '@/components/UserUpdate'
const UserInfo = () => {
    const element = (<><UserUpdate /></>);
    return element
}
export default UserInfo